import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Empty, Card, Col, Row } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import { entityActions, businessActions, exportConfigActions } from '../../redux/actions';

import PageHeader from '../../components/PageHeader';
import ExportTemplateModal from '../../components/ExportTemplateModal';
import EditExportTemplateModal from '../../components/EditExportTemplateModal';

const ExportConfig = () => {
    const dispatch = useDispatch();
    const entities = useSelector((state) => state.entities.entities);
    const fetchingEntities = useSelector((state) => state.entities.fetchingEntities);
    const businessCases = useSelector((state) => state.business.businessCases);
    const exportConfigs = useSelector((state) => state.exportConfigs.exportConfigs);
    const fetchingExportConfigs = useSelector((state) => state.exportConfigs.fetchingExportConfigs);
    const isEmpty = !fetchingExportConfigs && exportConfigs && !Object.keys(exportConfigs).length;
    const [isExportTemplateModalOpen, setIsExportTemplateModalOpen] = useState(false);
    const [isEditExportModalOpen, setIsEditExportModalOpen] = useState(false);
    const [config, setConfig] = useState({});

    useEffect(() => {
        dispatch(entityActions.getEntities());
        dispatch(businessActions.getBusinessCases());
        dispatch(exportConfigActions.fetchExportConfigs());
    }, [dispatch]);

    const handleAddNewExportConfig = () => {
        setIsExportTemplateModalOpen(true);
    };

    const onEditConfig = (currentConfig) => {
        setConfig(currentConfig);
        setIsEditExportModalOpen(true);
    };

    const onDeleteConfig = (id) => {
        dispatch(exportConfigActions.deleteExportConfig(id));
    };

    const renderContent = () => {
        if (fetchingEntities || entities == null || businessCases == null || exportConfigs == null) {
            return <></>;
        }

        return (
            <>
                <PageHeader
                    extra={[
                        <Button key="1" type="primary" onClick={handleAddNewExportConfig}>
                            New Export Template
                        </Button>,
                    ]}
                />
                <div style={{ padding: '0 24px' }}>
                    {isEmpty ? (
                        <Empty
                            style={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            }}
                        />
                    ) : (
                        <div style={{ padding: '10px 0' }}>
                            <Row gutter={[16, 16]}>
                                {exportConfigs.map((config) => (
                                    <Col key={config.export_config_id} span={6}>
                                        <Card
                                            className="clickable-card"
                                            hoverable
                                            actions={[
                                                <EditOutlined key="edit" onClick={() => onEditConfig(config)} />,
                                                <DeleteOutlined
                                                    key="delete"
                                                    onClick={() => onDeleteConfig(config.export_config_id)}
                                                />,
                                            ]}
                                        >
                                            <Card.Meta title={config.name} description={config.description} />
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    )}

                    <EditExportTemplateModal
                        config={config}
                        entities={entities}
                        businessCases={businessCases}
                        editCheckedScenarios={
                            config.export_entity != null
                                ? config.export_entity
                                      .filter((entity) => entity.entity_type === 'scenario')
                                      .map((scenario) => {
                                          return scenario.entity_id;
                                      })
                                : []
                        }
                        editCheckedBusinessCases={
                            config.export_entity != null
                                ? config.export_entity
                                      .filter((entity) => entity.entity_type === 'business')
                                      .map((scenario) => {
                                          return scenario.entity_id;
                                      })
                                : []
                        }
                        name={config.name}
                        description={config.description}
                        editable={false}
                        isEditModalOpen={isEditExportModalOpen}
                        handleClose={() => {
                            setIsEditExportModalOpen(false);
                            setConfig({});
                        }}
                    />

                    <ExportTemplateModal
                        entities={entities}
                        businessCases={businessCases}
                        editable={false}
                        isModalOpen={isExportTemplateModalOpen}
                        handleClose={() => {
                            setIsExportTemplateModalOpen(false);
                        }}
                    />
                </div>
            </>
        );
    };
    return renderContent();
};

export default ExportConfig;
